import { useQuery } from '@tanstack/react-query';
import { LegalKeySchema } from '@couch/shared';
import { Link, useParams } from 'react-router';
import { errorMessage } from '../api/client';
import { legalApi } from '../api/legal';
import { LegalLinks } from '../components/LegalLinks';

/** A legal page, readable without an account (doc 63). Plain text: line breaks kept, nothing in it runs. */
export function LegalPage() {
  const parsed = LegalKeySchema.safeParse(useParams().key);
  const key = parsed.success ? parsed.data : null;
  const page = useQuery({ queryKey: ['legal', key], queryFn: () => legalApi.page(key ?? 'impressum'), enabled: key !== null, retry: false });
  return (
    <main className="legal">
      <p><Link to="/">← Couch</Link></p>
      {key === null && <p role="alert" className="form-error">There is no such page.</p>}
      {page.isPending && key !== null && <p role="status">Loading…</p>}
      {page.isError && <p role="alert" className="form-error">{errorMessage(page.error)}</p>}
      {page.data && (
        <article aria-labelledby="legal-title">
          <h1 id="legal-title">{page.data.page.title}</h1>
          <div className="legal-text">{page.data.page.body}</div>
          <p className="muted">Last changed {new Date(page.data.page.updatedAt).toLocaleDateString()}</p>
        </article>
      )}
      <LegalLinks />
    </main>
  );
}
